
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import PricingPlans from './components/PricingPlans';
import ComparisonSection from './components/ComparisonSection';
import FAQSection from './components/FAQSection';

export default function Pricing() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <PricingPlans />
        <ComparisonSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}